




















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Resolve } from 'vue-di';
import { faEllipsisH, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { Title } from '~/decorators/Title';
import SessionModule from '~/store/session';
import styles from '~/assets/style/variables.scss';
import '@fortawesome/pro-light-svg-icons';
import { BaseView } from '~/components/BaseView';
import EnrollmentModule from '~/store/enrollment';
import EligibilityModule from '~/store/eligibility';
import { ProgramState } from '~/types/types';
import StyleService from '~/services/styleService';
import EventBus from '~/services/eventBus';
import Path from '~/store/path';

@Component<LandingPageButton>({
    // layout: 'authenticated',
    // middleware: 'authenticated',
})
@Title(process.env.NAME!)
export default class LandingPageButton extends BaseView {
    @Resolve
    enrollment!: EnrollmentModule;
    @Resolve
    eligibility!: EligibilityModule;
    @Resolve
    eventBus!: EventBus;
    @Resolve
    styleService!: StyleService;
    @Resolve
    public session!: SessionModule;
    @Resolve
    public path! :Path

    get styles() {
        return this.styleService.getProgramStyle(this.enrollment.programState);
    }

    get dashboard() {
        return this.$settings.landingMenu.filter(item => item.isLandingMenu);
    }

    selectEligibility(service: string) {
      switch (service) {
            case 'enroll':
                window.location.href = 'https://madrigalpatientsupport.com/enroll-patient/?src=Valeris';
                break;
            case 'hcp':
                this.path.setPath(service);
                this.$router.push({ name: 'provider-eligibility' });
                break;
            case 'portal-login':
                this.path.setPath(service);
                this.session.loginWithRedirect();
                break;
        }
    }

    handleClick(path: string, programState?: ProgramState) {
        if (programState) {
            this.enrollment.setProgramState(programState);
        }
        this.eventBus.nextProgramChange();
        this.$router.push(path);
    }

    mounted() {
        this.eligibility.clearStore();
        this.enrollment.clearPatientInformation();
        this.enrollment.clearInsuranceInformation();
        this.enrollment.clearEnrollmentInformation();
        this.enrollment.setProgramState(ProgramState.Gilead);
    }
}
